import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface NotificationStore {
  arePushNotificationsAllowed: boolean | undefined;
  setArePushNotificationsAllowed: (unixDate: boolean) => void;
  lastSubscriptionStatusSentAt: number | undefined;
  setLastSubscriptionStatusSentAt: (unixDate: number) => void;
}

export const usePushNotificationStore = create<NotificationStore>()(
  devtools(
    persist(
      (set) => ({
        arePushNotificationsAllowed: undefined,
        setArePushNotificationsAllowed: (bool) =>
          set(() => ({
            arePushNotificationsAllowed: bool,
          })),
        lastSubscriptionStatusSentAt: undefined,
        setLastSubscriptionStatusSentAt: (unixDate) =>
          set(() => ({
            lastSubscriptionStatusSentAt: unixDate,
          })),
      }),
      { name: 'ems-push-notification-store' }
    )
  )
);
